import PropTypes from 'prop-types';
import React, {
  useRef,
  useEffect,
  useCallback,
} from 'react';
import { Title } from '@skyline-platform/alchemy';
import './TableViewerLayout.css';

// @todo: refactor this component to use buttons
// (or another way to not nest interactive elements) for wcag
export const TableViewerLayout = ({
  tableTitle, viewerTitle, tableSlot, viewerSlot,
}) => {
  const allItemOpenCheckbox = useRef(false);
  const itemOpenCheckbox = useRef(false);

  useEffect(() => {
    // Set the allItemOpen checkbox to checked on mount
    if (allItemOpenCheckbox.current) {
      allItemOpenCheckbox.current.checked = true;
    }
  }, []);

  const handleTabDataPopulated = useCallback(() => {
    if (allItemOpenCheckbox.current?.checked === true) {
      allItemOpenCheckbox.current.checked = false;
    }
  }, []);

  const handleAllItemOpenKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      if (allItemOpenCheckbox.current) {
        allItemOpenCheckbox.current.checked = !allItemOpenCheckbox.current.checked;
      }
    }
  };

  const handleItemOpenKeyDown = (e) => {
    if (e.key === ' ' || e.key === 'Enter') {
      if (itemOpenCheckbox.current) {
        itemOpenCheckbox.current.checked = !itemOpenCheckbox.current.checked;
      }
    }
  };

  return (
    <main>
      <section>
        <div className='left drawer'>
          <Title level={1} title={tableTitle}>
            <div title='Slide Drawer View' className='slide-control'>
              <label
                htmlFor='itemOpen'
                onKeyDown={handleItemOpenKeyDown}
              >
                <span className='visually-hidden'>Fold Table View</span>
                <input
                  id='itemOpen'
                  type='checkbox'
                  ref={itemOpenCheckbox}
                />
                <i className='fa-solid fa-angle-left' aria-hidden='true' style={{ color: 'white' }} />
              </label>
              <label
                htmlFor='allItemOpen'
                onKeyDown={handleAllItemOpenKeyDown}
              >
                <span className='visually-hidden'>Fold Viewer</span>
                <input
                  id='allItemOpen'
                  type='checkbox'
                  ref={allItemOpenCheckbox}
                />
                <i className='fa-solid fa-angle-right' aria-hidden='true' style={{ color: 'white' }} />
              </label>
            </div>
          </Title>
          <div className='component-slot'>
            {tableSlot}
          </div>
        </div>
      </section>

      <section>
        <div className='right drawer'>
          <Title
            backgroundColor='transparent'
            textColor='var(--vp-dark-blue)'
            title={viewerTitle}
            aria-hidden={!viewerSlot ? 'true' : undefined}
          />
          {/* remove from tab order to avoid an extra tab in Firefox */}
          {viewerSlot && <div className='component-slot' tabIndex={-1} aria-label="Details panel">
            {/* eslint-disable-next-line react-hooks/refs */}
            {React.cloneElement(viewerSlot, { onTabDataPopulate: handleTabDataPopulated })}
          </div>}
        </div>
        <div className='anchor' aria-hidden='true' />
      </section>
    </main>
  );
};

TableViewerLayout.propTypes = {
  tableTitle: PropTypes.string.isRequired,
  viewerTitle: PropTypes.string.isRequired,
  tableSlot: PropTypes.node.isRequired,
  viewerSlot: PropTypes.node.isRequired,
};